module.exports = __webpack_public_path__ + "static/media/TSS_Background.e1c79d89.jpg";